import React from 'react';
import { Outlet } from 'react-router-dom';
import { SheinShopProvider } from '@/shein-platform/context/SheinShopContext';
import '@/styles/shein-platform/shein-platform.css';
import '@/styles/shein-platform/shein-product-ops.css';
import '@/styles/shein-platform/shein-notice-help.css';

/**
 * 通知帮助中心独立布局：无 SHEIN 顶栏、无左侧菜单；内容铺满整页。
 */
export default function SheinStandaloneHelpLayout() {
  return (
    <SheinShopProvider>
      <div className="shein-help-standalone" data-testid="shein-standalone-help-layout">
        <Outlet />
      </div>
    </SheinShopProvider>
  );
}
